<script setup lang="ts">
import { computed } from 'vue'
import AppErrorPageBlock from '~/components/app/AppErrorPageBlock.vue'
import AppErrorShell from '~/components/app/AppErrorShell.vue'
import { classifyNuxtErrorToScreenModel } from '~/composables/ui/useAppError'
import { useRecetteDocumentTitle } from '~/composables/layout/useAppEnv'

useRecetteDocumentTitle()

const error = useError()

const screen = computed(() => classifyNuxtErrorToScreenModel(error.value ?? undefined))

useHead({
  title: computed(() => screen.value.title),
})

// Une seule racine dans le template (pas de commentaire HTML au même niveau qu’un composant) :
// sinon Vue produit un fragment, le SSR d’erreur Nuxt peut retomber sur le gabarit par défaut
// et l’hydratation casse (écran vide, TypeError sur setAttribute).
</script>

<template>
  <AppErrorShell>
    <div class="error-page-root">
      <AppErrorPageBlock
        :model="screen"
        clear-error-boundary
        full-height
      />
    </div>
  </AppErrorShell>
</template>

<style scoped lang="scss">
.error-page-root {
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  box-sizing: border-box;
}
</style>
